import React from "react";
import styles from "../Banner-v1/banner-v1.module.css";
import PreloadImage from "../../PreloadImage";
import Animations from "../../Animations/animations";
import { Link } from "react-router-dom";

const BannerV1 = ({ image, noPadding, headingOne, subText, alignCenter, flexColumn, flexImages, backgroundImage }) => {
  const bannerV1Style = {
    paddingBottom: noPadding ? "0" : "100px",
  };

  const bannerV1Flex = {
    flexDirection : flexColumn ? "column" : "initial",
    gap: "20px 100px",
  };
  const bannerV1align = {
    textAlign: alignCenter ? "center" : "left",
  }

  const bannerV1Images = {
    display: "flex" ,  
    justifyContent: "center",
    alignItems: "center",
  };

  const bannerV1Bg = backgroundImage
  ? {
    background: `url(${backgroundImage.url})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  }
  :
  {};

  const combinedStyles ={
    ...bannerV1Flex,
    ...bannerV1Bg
  }
  
  return (
    <section className={styles.banner_v1} style={bannerV1Style}>
      <div className={styles.container} style={combinedStyles}>
        <div className={styles.banner_v1__text} style={bannerV1align}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h1>
            <span style={{ color: "#6874E8", fontWeight: 700 }}>
              {headingOne.mainTitle}:{" "}
            </span>
            {headingOne.subTitle}
            {headingOne.subTitle && headingOne.subTitle.trim() !== "" && <br />}
            <span className={styles.highlighted_text}>
              <span
                style={{
                  color: headingOne.mainTitle === "Yalla" ? "#fff" : "#FAA916",
                }}
              >
                {headingOne.highlightedText[0]}
              </span>{" "}
              <span
                style={{
                  color: headingOne.mainTitle === "Yalla" ? "#FAA916" : "#fff",
                }}
              >
                {headingOne.highlightedText[1]}
              </span>
            </span>
            <br />
            {headingOne.description}
          </h1>
          </Animations>
          <Animations animationType="fadeInUp" threshold={0.2}>
          <p className={styles.subText}>{subText}</p>
          </Animations>
          <Animations animationType="fadeInUp" threshold={0.2}>
<div >
<Link to="/contact" className={styles.banner_v1__cta}>Get a Quote
            <img
              src="assets/right-arrow.webp"
              width="11"
              height="11"
              alt="arrow"
              loading="lazy"
            />

          </Link>
          </div>
          </Animations>
        </div>

        <div className={styles.banner_v1__img}>
  {/* Ensure that image is always treated as an array */}
  {Array.isArray(image) ? (
    <div style={flexImages ? bannerV1Images : {}} className={styles.bannerImages}>
      {image.map((img, index) => (
        <div key={index}>
          <div>
            <PreloadImage src={img.url} alt={img.alt} width="100%" height="100%" fetchPriority="high"/>
          </div>
        </div>
      ))}
    </div>
  ) : (
    // If image is not an array, treat it as a single image object
    <div>
      <div>
        <PreloadImage src={image.url} alt={image.alt} width="100%" height="100%"/>
      </div>
    </div>
  )}
</div>


      </div>
    </section>
  );
};

export default BannerV1;
